import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PageHero from "../components/child/PageHero";
import CampaignLayer from "../components/CampaignLayer";

const CampaignList = () => (
  <MasterLayout>
    <PageHero
      title="Campaigns"
      subtitle="Schedule and track bulk WhatsApp broadcasts across your sessions."
      badge={{ icon: "mdi:bullhorn-outline", label: "Broadcasts" }}
    />
    <CampaignLayer />
  </MasterLayout>
);

export default CampaignList;
